<template>
  <div class="orgDetail">
    <div class="left-box">
      <leftPage :active="1" :org_id="org_id"/>
    </div>
    <div class="right-box">
      <div class="title-box">
        <div class="tit-left">
          <div class="icon-box">
            <i class="iconfont icon-zhengxinxinxi"></i>
          </div>
          <b>基础信息 <span>(以下内容由教培机构填写)</span></b>
        </div>
      </div>
      <div class="form-content">
        <el-form :model="ruleForm" :rules="rules" :disabled="true" ref="ruleForm" label-position="top"
                 class="ruleFormYan">
          <el-row :gutter="20">
            <el-col
              :span="24">
              <el-form-item class="errorTips logo-item" label="机构头像" ref="logo" prop="logo">
                <div class="flex justify-start">
                  <!--                  <upload-file-->
                  <!--                    name="logo"-->
                  <!--                    @uploadFile="uploadFile"-->
                  <!--                  >-->
                  <div class="logo" slot="upload">
                    <img :src="ruleForm.logo" v-if="ruleForm.logo" alt="">
                    <i class="iconfont icon-a-fenzu1" v-else></i>
                  </div>
                  <!--                  </upload-file>-->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="机构办公地" ref="use_address" prop="use_address">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.use_address" class="inp"></el-input>
<!--                  <div class="tips">-->
<!--                    <i class="iconfont icon-xinxitishi"></i>注：请填写校区实际办学地址-->
<!--                  </div>-->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="机构办公地所在楼层" ref="floor" prop="floor">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.floor" class="inp">
                    <template slot="append">层</template>
                  </el-input>
<!--                  <div class="tips">-->
<!--                    <i class="iconfont icon-xinxitishi"></i>注：请填写校区实际办学地址所在楼层-->
<!--                  </div>-->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
<!--              <div class="flex justify-start align-center">-->
                  <el-form-item ref="lease_contract_start" label="场地房屋租赁起始日期" prop="lease_contract_start">
                    <div class="flex justify-start align-center">
                      <el-date-picker
                        class="inp"
                        v-model="ruleForm.lease_contract_start"
                        :clearable="false"
                        type="date"
                        placeholder="选择日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                      </el-date-picker>
<!--                      <div class="tips">-->
<!--                        <i class="iconfont icon-xinxitishi"></i>注：请填写房屋租赁合同起始日期-->
<!--                      </div>-->
                    </div>
                  </el-form-item>
<!--              </div>-->
            </el-col>
            <el-col :span="12">
              <div class="flex justify-start align-center">
                <div class="flex-sub flex-sub-w0">
                  <el-form-item ref="lease_contract_end" label="场地房屋租赁截止日期" prop="lease_contract_end">
                    <div class="flex justify-start align-center">
                      <el-date-picker
                        class="inp"
                        v-model="ruleForm.lease_contract_end"
                        :clearable="false"
                        type="date"
                        placeholder="选择日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                      </el-date-picker>
<!--                      <div class="tips">-->
<!--                        <i class="iconfont icon-xinxitishi"></i>注：请填写房屋租赁合同截止日期-->
<!--                      </div>-->
                    </div>
                  </el-form-item>
                </div>
                <el-form-item class="errorTips" ref="lease_contract" prop="lease_contract">
                  <div class="flex justify-start align-center">
                    <a :href="ruleForm.lease_contract" target="_blank" download rel="noopener"
                       v-if="ruleForm.lease_contract"
                       class="look">查看合同</a>
                    <!--                    <upload-file-->
                    <!--                      class="upZuj"-->
                    <!--                      name="lease_contract"-->
                    <!--                      @uploadFile="uploadFile"-->
                    <!--                    >-->
                    <!--                      <div class="btnUp" slot="upload">-->
                    <!--                        <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传房屋租赁合同-->
                    <!--                      </div>-->
                    <!--                    </upload-file>-->
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <el-form-item label="建筑面积（m2）" ref="area" prop="area">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.area" class="inp">
                    <template slot="append">㎡</template>
                  </el-input>
<!--                  <div class="tips">-->
<!--                    <i class="iconfont icon-xinxitishi"></i>注：请填写根据房屋租赁合同或产权证明标注的建筑面积填写-->
<!--                  </div>-->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="营业执照开始日期" ref="build_date" prop="build_date">
                <div class="flex justify-start align-center">
                  <el-date-picker
                    class="inp"
                    v-model="ruleForm.build_date"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div class="flex justify-start align-center">
                <div class="flex-sub flex-sub-w0">
                  <el-form-item label="是否与学员签订培训合同" ref="apprenticeship_contract" prop="apprenticeship_contract">
                    <div class="flex justify-start align-center">
                      <el-select v-model="ruleForm.apprenticeship_contract" placeholder="请选择" class="inp">
                        <el-option
                          v-for="item in isYes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
<!--                      <div class="tips" v-if="ruleForm.apprenticeship_contract == 1">-->
<!--                        <i class="iconfont icon-xinxitishi"></i>注：请上传机构实际使用的文本合同，多种合同请打包上传-->
<!--                      </div>-->
                    </div>
                  </el-form-item>
                </div>
                <el-form-item label="" class="errorTips" ref="apprenticeship_contract_files"
                              prop="apprenticeship_contract_files" v-if="ruleForm.apprenticeship_contract == 1">
                  <div class="flex justify-start align-center">
                    <a :href="ruleForm.apprenticeship_contract_files"
                       v-if="ruleForm.apprenticeship_contract_files"
                       target="_blank" class="look">查看合同</a>
                    <!--                    <upload-file-->
                    <!--                      v-if="ruleForm.apprenticeship_contract == 1"-->
                    <!--                      class="upZuj"-->
                    <!--                      name="apprenticeship_contract_files"-->
                    <!--                      @uploadFile="uploadFile"-->
                    <!--                    >-->
                    <!--                      <div class="btnUp" slot="upload">-->
                    <!--                        <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传培训合同-->
                    <!--                      </div>-->
                    <!--                    </upload-file>-->
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12" v-if="ruleForm.apprenticeship_contract == 1">
              <!--       是否与学员签订培训合同选择是 显示这个       -->
              <el-form-item label="是否使用科技部门示范合同文本" ref="contract_use_model" prop="contract_use_model">
                <div class="flex justify-start align-center">
                  <el-select v-model="ruleForm.contract_use_model" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in isYes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <a :href="fileUrl + '/uploads/files/shifanhetong.docx'" class="look" style="margin-top: 0;"
                     download="示范合同文本">下载示范合同文本</a>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-for="(item,index) in ruleForm.institutional_situation" :key="item.date">
              <div class="flex justify-start align-center">
                <div class="flex-sub flex-sub-w0">
                  <el-form-item label="机构管理制度情况"
                                :ref="'institutional_situation.' + index + '.value'"
                                :prop="'institutional_situation.' + index + '.value'"
                                :rules="{
                                required: false, message: '请选择', trigger: 'change'
                              }">
                    <div class="flex justify-start align-center">
                      <el-select v-model="item.value" placeholder="请选择" class="inp">
                        <el-option
                          v-for="item in zhiduOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
<!--                      <div class="tips">-->
<!--                        <i class="iconfont icon-xinxitishi"></i>注：制度需加盖机构公章-->
<!--                      </div>-->
                    </div>
                  </el-form-item>
                </div>
                <el-form-item label="" class="errorTips"
                              :ref="'institutional_situation.' + index + '.file'"
                              :prop="'institutional_situation.' + index + '.file'"
                              :rules="{
                                required: false, message: '请上传', trigger: 'change'
                              }">
                  <div class="flex justify-start align-center">
                    <a :href="item.file" target="_blank" v-if="item.file" class="look">查看制度</a>
                    <!--                    <upload-file-->
                    <!--                      class="upZuj"-->
                    <!--                      name="institutional_situation"-->
                    <!--                      :index="index"-->
                    <!--                      @uploadFile="uploadFile"-->
                    <!--                    >-->
                    <!--                      <div class="btnUp" slot="upload">-->
                    <!--                        <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传制度-->
                    <!--                      </div>-->
                    <!--                    </upload-file>-->
                    <!--                    <img src="@/assets/images/tianjiaicon.png" v-if="index == 0" class="add" @click="addZhiDu()" alt="">-->
                    <!--                    <img src="@/assets/images/jianhaoicon.png" v-else class="add" @click="delZhiDu(index)" alt="">-->
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上传承诺书" ref="chengnuoshu" prop="chengnuoshu">
                <div class="flex justify-start align-center">
                  <a :href="ruleForm.chengnuoshu"
                     v-if="ruleForm.chengnuoshu"
                     target="_blank" style="margin-top: 0;" class="look">查看承诺书</a>
                  <!--                  <upload-file-->
                  <!--                    name="chengnuoshu"-->
                  <!--                    @uploadFile="uploadFile"-->
                  <!--                  >-->
                  <!--                    <div class="btnUp" slot="upload">-->
                  <!--                      <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传承诺书-->
                  <!--                    </div>-->
                  <!--                  </upload-file>-->
                  <a :href="fileUrl + '/uploads/files/chengnuoshu.docx'" class="look" style="margin-top: 0;"
                     download="承诺书模板">下载承诺书模板</a>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!--        <div class="btn-box">-->
        <!--          <div class="btn" @click="submitruleForm('ruleForm')">保存</div>-->
        <!--        </div>-->
      </div>
      <div class="title-box">
        <div class="tit-left">
          <div class="icon-box">
            <i class="iconfont icon-zhengxinxinxi"></i>
          </div>
          <b>基础信息 <span>(以下信息由行业主管部门授权提供，机构如有异议，可自行编辑修改，保存提交至行业主管部门审核)</span></b>
        </div>
      </div>
      <div class="form-content">
        <el-form :model="getForm" :rules="rules" ref="getForm" label-position="top" class="ruleFormYan">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="机构名称" ref="org_name" prop="org_name">
                <div class="flex justify-start align-center">
                  <el-input v-model="getForm.org_name" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码" ref="org_code" prop="org_code">
                <div class="flex justify-start align-center">
                  <el-input v-model="getForm.org_code" placeholder="请输入" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="机构住所地" ref="reg_address" prop="reg_address">
                <div class="flex justify-start align-center">
                  <el-input v-model="getForm.reg_address" placeholder="请输入" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册资本" ref="zhuce_ziben" prop="zhuce_ziben">
                <div class="flex justify-start align-center">
                  <el-input v-model="getForm.zhuce_ziben" class="inp">
                    <template slot="append">万元</template>
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="实缴资本" ref="shijiao_ziben" prop="shijiao_ziben">
                <div class="flex justify-start align-center">
                  <el-input v-model="getForm.shijiao_ziben" class="inp">
                    <template slot="append">万元</template>
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否具有法人资格" ref="is_faren_banxue" prop="is_faren_banxue">
                <div class="flex justify-start align-center">
                  <el-select v-model="getForm.is_faren_banxue" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in isYes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商业品牌" ref="brand" prop="brand">
                <div class="flex justify-start align-center">
                  <el-input v-model="getForm.brand" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否集团化办学" ref="have_group" prop="have_group">
                <div class="flex justify-start align-center">
                  <el-select v-model="getForm.have_group" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in isYes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="getForm.have_group == 1">
              <el-form-item label="所属集团" ref="group" prop="group">
                <div class="flex justify-start align-center">
                  <el-input v-model="getForm.group" placeholder="请输入" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否注册全国平台" ref="is_reg" prop="is_reg">
                <div class="flex justify-start align-center">
                  <el-select v-model="getForm.is_reg" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in isYes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否取得培训许可证" ref="is_license_able" prop="is_license_able">
                <div class="flex justify-start align-center">
                  <el-select v-model="getForm.is_license_able" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in isYes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="getForm.is_license_able == 1">
              <el-form-item label="办学许可证号" ref="xuke_no" prop="xuke_no">
                <div class="flex justify-start align-center">
                  <el-input v-model="getForm.xuke_no" placeholder="请输入" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="getForm.is_license_able == 1">
              <el-form-item label="办学许可证注册地址" ref="xuke_zhucedi" prop="xuke_zhucedi">
                <div class="flex justify-start align-center">
                  <el-input v-model="getForm.xuke_zhucedi" placeholder="请输入" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <!--            <el-col :span="12" v-if="getForm.is_license_able == 1">-->
            <!--              <el-form-item label="办学许可证办学内容" ref="xuke_con" prop="xuke_con">-->
            <!--                <div class="flex justify-start align-center">-->
            <!--                  <el-input v-model="getForm.xuke_con" placeholder="请输入" class="inp"></el-input>-->
            <!--                </div>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <el-col :span="12" v-if="getForm.is_license_able == 1">
              <el-form-item ref="xuke_set_date" label="办学许可证设立时间" prop="xuke_set_date">
                <div class="flex justify-start align-center">
                  <el-date-picker
                    class="inp"
                    v-model="getForm.xuke_set_date"
                    :clearable="false"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="getForm.is_license_able == 1">
              <el-form-item ref="xuke_date" label="办学许可证到期时间" prop="xuke_date">
                <div class="flex justify-start align-center">
                  <el-date-picker
                    class="inp"
                    v-model="getForm.xuke_date"
                    :clearable="false"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-for="(item,index) in getForm.fire_safes" :key="item.date">
              <div class="flex justify-start align-center">
                <div class="flex-sub flex-sub-w0">
                  <el-form-item label="消防安全情况"
                                :ref="'fire_safes.' + index + '.value'"
                                :prop="'fire_safes.' + index + '.value'"
                                :rules="{
                                required: false, message: '请选择', trigger: 'change'
                              }">
                    <div class="flex justify-start align-center">
                      <el-select v-model="item.value" placeholder="请选择" @change="xFangChange" class="inp">
                        <el-option
                          v-for="item in xiaofangOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </div>
                <el-form-item class="errorTips"
                              :ref="'fire_safes.' + index + '.file'"
                              :prop="'fire_safes.' + index + '.file'"
                              :rules="{
                                required: false, message: '请上传', trigger: 'change'
                              }">
                  <div class="flex justify-start align-center" v-if="getForm.fire_safes[0].value != 4">
                    <a :href="item.file" target="_blank" class="look" v-if="item.file">查看附件</a>
                    <upload-file
                      class="upZuj"
                      name="fire_safes"
                      :index="index"
                      @uploadFile="uploadFile2"
                    >
                      <div class="btnUp" slot="upload">
                        <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传附件
                      </div>
                    </upload-file>
                    <img src="@/assets/images/tianjiaicon.png" v-if="index == 0" class="add" @click="addXfang()" alt="">
                    <img src="@/assets/images/jianhaoicon.png" v-else class="add" @click="delXfang(index)" alt="">
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否存量机构" ref="is_stock_org" prop="is_stock_org">
                <div class="flex justify-start align-center">
                  <el-select v-model="getForm.is_stock_org" placeholder="请选择" class="inp">
                    <el-option
                      v-for="item in isYes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
        <div class="btn-box">
          <div class="btn" @click="submitgetForm('getForm')">保存</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import leftPage from "@/views/admin/pages/orgDetail/common/leftPage";
import UploadFile from "@/components/UploadFile";
import {
  scrollIntoView
} from "@/utils/utils";
import {
  isYes, xiaofangOptions,
  zhiduOptions
} from "@/utils/const";
import {fileUrl} from "@/config";
import {
  save_base,
  save_check,
  get_base_info
} from '@/api/admin'

export default {
  name: "orgDetail",
  data() {
    return {
      org_id: '',
      fileUrl: fileUrl,
      isYes: isYes,
      zhiduOptions: zhiduOptions,
      xiaofangOptions: xiaofangOptions,
      ruleForm: {
        logo: '', // 机构头像
        use_address: '', // 实际经营地址
        floor: '', // 实际经营地所在楼层
        lease_contract_start: '', // 场地房屋租赁起日期
        lease_contract_end: '', // 场地房屋租赁止日期
        lease_contract: '', // 房屋租赁合同
        area: '', // 培训场地建筑面积
        build_date: '', // 机构成立时间
        apprenticeship_contract: '', // 是否与学员签订培训合同
        apprenticeship_contract_files: '', // 合同
        contract_use_model: '', // 是否使用科技部门示范合同文本
        institutional_situation: [
          {
            value: '',
            file: '',
            date: Date.now()
          }
        ],
        chengnuoshu: '', // 承诺书
      },
      getForm: {
        org_name: '', // 机构名称
        zhuce_ziben: '', // 注册资本
        shijiao_ziben: '', // 实缴资本
        is_faren_banxue: '', // 是否法人主体办学
        brand: '', // 商业品牌
        have_group: '', // 是否集团化办学
        group: '', // 所属集团
        is_reg: '', // 是否注册全国平台
        is_license_able: '', // 培训许可证情况
        xuke_no: '', //办学许可证号
        xuke_zhucedi: '', // 办学许可证注册地址
        xuke_con: '', // 办学许可证办学内容
        xuke_set_date: '', // 办学许可证设立时间
        xuke_date: '', // 办学许可证到期时间

        fire_safes: [
          {
            value: '',
            file: '',
            date: Date.now()
          }
        ],
        is_stock_org: '', // 是否存量机构
        org_code: '', // 统一社会信用代码
        reg_address: '', // 注册地址
      },
      rules: {
        chengnuoshu: [
          {required: false, message: '请上传', trigger: 'change'}
        ],
        logo: [
          {required: false, message: '请上传', trigger: 'change'}
        ],
        xuke_con: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        xuke_zhucedi: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        xuke_no: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        reg_address: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        org_code: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        group: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        brand: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        shijiao_ziben: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        zhuce_ziben: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        org_name: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        xuke_date: [
          {required: false, message: '请选择', trigger: 'blur'}
        ],
        xuke_set_date: [
          {required: false, message: '请选择', trigger: 'blur'}
        ],
        build_date: [
          {required: false, message: '请选择', trigger: 'blur'}
        ],
        is_stock_org: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        lease_contract: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        apprenticeship_contract_files: [
          {required: false, message: '请上传', trigger: 'change'}
        ],
        license_time_start: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_license_able: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_reg: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        have_group: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_faren_banxue: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        institutional_situation: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        contract_use_model: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        apprenticeship_contract: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        area: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        lease_contract_start: [
          {required: false, message: '请选择', trigger: 'blur'}
        ],
        use_address: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        floor: [
          {required: false, message: '请输入', trigger: 'blur'}
        ]
      }
    }
  },
  components: {
    leftPage,
    UploadFile
  },
  created() {
    this.$emit("setActive", {
      headActive: 2
    })
    this.org_id = this.$route.query.org_id
    this.init()
  },
  methods: {
    async init() {
      let _data = await get_base_info(this.org_id);
      if (_data.status == 200) {
        this.ruleForm = {
          logo: _data.data.logo, // 机构头像
          use_address: _data.data.use_address, // 实际经营地址
          floor: _data.data.floor, // 实际经营地所在楼层
          lease_contract_start: _data.data.lease_contract_start, // 场地房屋租赁起日期
          lease_contract_end: _data.data.lease_contract_end, // 场地房屋租赁起日期
          lease_contract: _data.data.lease_contract, // 房屋租赁合同
          area: _data.data.area, // 培训场地建筑面积
          build_date: _data.data.build_date ? _data.data.build_date : '', // 机构成立时间
          apprenticeship_contract: _data.data.apprenticeship_contract, // 是否与学员签订培训合同
          apprenticeship_contract_files: _data.data.apprenticeship_contract_files, // 合同
          contract_use_model: _data.data.contract_use_model, // 是否使用科技部门示范合同文本
          institutional_situation: _data.data.institutional_situation ? JSON.parse(_data.data.institutional_situation) : [{
            value: '',
            file: '',
            date: Date.now()
          }],
          chengnuoshu: _data.data.chengnuoshu
        }
        this.getForm = {
          org_name: _data.data.org_name, // 机构名称
          zhuce_ziben: _data.data.zhuce_ziben, // 注册资本
          shijiao_ziben: _data.data.shijiao_ziben, // 实缴资本
          is_faren_banxue: _data.data.is_faren_banxue, // 是否法人主体办学
          brand: _data.data.brand, // 商业品牌
          have_group: _data.data.have_group, // 是否集团化办学
          group: _data.data.group, // 所属集团
          is_reg: _data.data.is_reg, // 是否注册全国平台
          is_license_able: _data.data.is_license_able, // 培训许可证情况
          xuke_no: _data.data.xuke_no, //办学许可证号
          xuke_zhucedi: _data.data.xuke_zhucedi, // 办学许可证注册地址
          xuke_con: _data.data.xuke_con, // 办学许可证办学内容
          xuke_set_date: _data.data.xuke_set_date, // 办学许可证设立时间
          xuke_date: _data.data.xuke_date, // 办学许可证到期时间
          fire_safes: _data.data.fire_safes ? JSON.parse(_data.data.fire_safes) : [{
            value: '',
            file: '',
            date: Date.now()
          }],
          is_stock_org: _data.data.is_stock_org, // 是否存量机构
          org_code: _data.data.org_code, // 统一社会信用代码
          reg_address: _data.data.reg_address // 注册地址
        }
      } else {
        this.$message.error(_data.msg)
      }
    },
    submitruleForm(formName) {
      this.$refs[formName].validate((valid, validates) => {
        if (valid) {
          this.submitInfo()
        } else {
          scrollIntoView(this, validates)
        }
      });
    },
    submitgetForm(formName) {
      this.$refs[formName].validate((valid, validates) => {
        if (valid) {
          this.submitgetInfo()
        } else {
          scrollIntoView(this, validates)
        }
      });
    },
    async submitgetInfo() {
      let _data = await save_check(
        this.org_id,
        this.getForm.org_name,
        this.getForm.zhuce_ziben,
        this.getForm.shijiao_ziben,
        this.getForm.is_faren_banxue,
        this.getForm.brand,
        this.getForm.have_group,
        this.getForm.group,
        this.getForm.is_reg,
        this.getForm.is_license_able,
        this.getForm.xuke_no,
        this.getForm.xuke_zhucedi,
        this.getForm.xuke_con,
        this.getForm.xuke_set_date,
        this.getForm.xuke_date,
        JSON.stringify(this.getForm.fire_safes),
        this.getForm.is_stock_org,
        this.getForm.org_code,
        this.getForm.reg_address
      )
      if (_data.status === 200) {
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },
    async submitInfo() {
      let _data = await save_base(
        this.org_id,
        this.ruleForm.logo,
        this.ruleForm.use_address,
        this.ruleForm.floor,
        this.ruleForm.lease_contract_start,
        this.ruleForm.lease_contract_end,
        this.ruleForm.lease_contract,
        this.ruleForm.area,
        this.ruleForm.build_date,
        this.ruleForm.apprenticeship_contract,
        this.ruleForm.apprenticeship_contract_files,
        this.ruleForm.contract_use_model,
        JSON.stringify(this.ruleForm.institutional_situation),
        this.ruleForm.chengnuoshu
      )
      if (_data.status === 200) {
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },
    uploadFile(data) {
      if (data.index === '') {
        this.ruleForm[data.name] = data.file.url
      } else {
        this.ruleForm[data.name][data.index].file = data.file.url
      }
    },
    uploadFile2(data) {
      this.getForm[data.name][data.index].file = data.file.url
    },
    xFangChange(e) {
      if (e == 4) {
        this.getForm.fire_safes = [{
          value: 4,
          file: '',
          date: Date.now()
        }];
      }
    },
    addZhiDu() {
      this.ruleForm.institutional_situation.push({
        value: '',
        file: '',
        date: Date.now()
      });
    },
    delZhiDu(index) {
      this.ruleForm.institutional_situation.splice(index, 1);
    },
    addXfang() {
      this.getForm.fire_safes.push({
        value: '',
        file: '',
        date: Date.now()
      });
    },
    delXfang(index) {
      this.getForm.fire_safes.splice(index, 1);
    }
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
/deep/ {
  .ruleFormYan .logo-item .el-form-item__content {
    height: auto;
    line-height: initial;
  }
}

.orgDetail {
  width: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;
  display: flex;
  justify-content: flex-start;

  .right-box {
    flex: 1;
    margin-left: 25px;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    border-radius: 8px;
    border: solid 1px #ffffff;
    padding: 0 20px;

    .form-content {
      width: 100%;
      padding: 20px 0;

      .width {
        width: 400px;
      }

      .logo {
        width: 150px;
        height: 150px;
        border-radius: 75px;
        border: 1px solid #dfe1f0;
        text-align: center;
        line-height: 150px;
        cursor: pointer;
        overflow: hidden;
        margin-left: 100px;

        i {
          font-size: 60px;
          color: #b9b6b6;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
        }
      }

      .btn-box {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 30px 0;

        .btn {
          width: 180px;
          height: 40px;
          background-image: linear-gradient(0deg,
            #2791ff 0%,
            #81b6ff 100%);
          border-radius: 20px;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          letter-spacing: 1px;
          color: #ffffff;
          cursor: pointer;
        }
      }

      .add {
        width: 36px;
        margin-left: 10px;
        margin-top: 15px;
        cursor: pointer;
      }

      .inp {
        flex: 1;
      }

      .tips {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        background-color: #fef0ef;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
        color: #f34336;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 16px;

        i {
          font-size: 20px;
          color: #f34336;
          margin-right: 4px;
        }

        &.width {
          width: 160px;
        }
      }

      .look {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        border: 1px solid #2791ff;
        color: #2791ff;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        margin-left: 10px;
        border-radius: 4px;
        margin-top: 15px;
      }

      .btnUp {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        margin-left: 10px;
        background-image: linear-gradient(90deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #ffffff;

        i {
          font-size: 20px;
          color: #ffffff;
          margin-right: 5px;
          font-weight: 100;
        }
      }
    }

    .title-box {
      width: 100%;
      height: 60px;
      border-bottom: solid 2px #e3e7f0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .tit-left {
        display: flex;
        justify-content: flex-start;
        padding-top: 25px;
        padding-bottom: 15px;

        .icon-box {
          width: 30px;
          height: 30px;
          background-image: linear-gradient(-30deg,
            #3579fb 0%,
            #44a3ff 100%);
          box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
          border-radius: 10px;
          text-align: center;
          line-height: 30px;

          i {
            font-size: 17px;
            color: #ffffff;
          }
        }


        b {
          font-size: 22px;
          color: #16181d;
          font-weight: bold;
          margin-left: 5px;
          span {
            font-size: 18px;
            color: #f74945;
          }
        }
      }
    }
  }

  .left-box {
    width: 260px;
  }
}
</style>


